import { StrictMode, useEffect, useMemo, useState } from "react";
import { createRoot } from "react-dom/client";
import {
  App,
  CloudLogin,
  I18nProvider,
  applyTheme,
  readTheme,
} from "@orni/ui";
import type { AuthState } from "@orni/ui";
import { CloudWebAuth, cloudFetcher, cloudOrigin, useDevProxy } from "./cloud-auth";
import { createCloudDesktopClient } from "../../desktop-next/src/cloud-desktop-client";
import "@orni/ui/styles.css";

applyTheme(readTheme());

function CloudShell() {
  const auth = useMemo(() => new CloudWebAuth(), []);
  // In development, keep the client on the page origin so auth cookies and
  // API requests both pass through Vite's /auth and /v1 proxy. A direct
  // 127.0.0.1:57900 request is a different browser origin and silently loses
  // the session cookie, which presents as an empty computer list.
  const client = useMemo(() => createCloudDesktopClient({
    cloudOrigin: useDevProxy ? "" : cloudOrigin,
    fetcher: cloudFetcher,
    recoverUnauthorized: () => auth.recoverUnauthorized(),
  }), [auth]);
  const [state, setState] = useState<AuthState>(auth.state);
  useEffect(() => {
    void auth.initialize();
    return auth.subscribe(setState);
  }, [auth]);
  useEffect(() => () => { auth.dispose(); client.dispose(); }, [auth, client]);
  if (state !== "authenticated") return <CloudLogin auth={auth} />;
  return <App auth={auth} client={client} />;
}

createRoot(document.getElementById("root")!).render(<StrictMode><I18nProvider><CloudShell /></I18nProvider></StrictMode>);
